export const WALLET_SETUP_ROUTES = {
  WALLET_SETUP: '/wallet/setup',
  PASSWORD: '/wallet/setup/password',
  IMPORT_SEED: '/wallet/setup/seed',
  BACKUP_SEED: '/wallet/setup/backup-seed',
  CONNECT_PLUG: '/wallet/setup/connect-plug',
  SUCCESS: '/wallet/setup/success',
}
